<template>
    <div class="flipbook">
        
        <div class="viewer" :class="{ zoomed: isZoom }">
            <div class="toolbar">
                <button @click="prev">&laquo;</button>
                <button @click="zoomIn">+</button>
                <button @click="zoomOut">-</button>
                <button @click="next">&raquo;</button>
                <button @click="close">FECHAR</button>
            </div>
            <div class="main-view">
                <div class="zoom-viewport" ref="zoomviewport">
                    <div id="flipbook" ref="flipbook">
                        <!--
                    <div v-for="page in imagens" :key="`${page.src}.${page.documento_id}`">
                        <img :src="page.src" alt="">
                    </div>
                    -->
                        <div>
                            <div class="loading">
                                <img src="/images/loading.svg" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from "jquery";
import turn from "/plugins/turn";
import zoom from "/plugins/zoom";

export default {
    props: ["documentos"],
    data() {
        return {
            key: 1,
            currentPage: 1,
            data: [],
            isZoom: false,
        };
    },
    methods: {
        close() {
            this.$emit("close");
        },
        zoomIn() {
            let $zoomviewport = $(this.$refs.zoomviewport);
            $zoomviewport.zoom("zoomIn");
            this.isZoom = true;
        },
        zoomOut() {
            let $zoomviewport = $(this.$refs.zoomviewport);
            $zoomviewport.zoom("zoomOut");
            this.isZoom = false;
        },
        next() {
            let $flipbook = $(this.$refs.flipbook);
            $flipbook.turn("next");
        },
        prev() {
            let $flipbook = $(this.$refs.flipbook);
            $flipbook.turn("previous");
        },
        async resize() {
            
            let images = await Promise.all(
                this.imagens.map(
                    (src) =>
                        new Promise((resolve, reject) => {
                            let img = new Image();
                            img.onload = () => resolve(img);
                            img.onerror = reject;
                            img.src = src;
                        })
                )
            );

            let width = 0;
            let height = 0;

            images.forEach((img) => {
                width = Math.max(img.width, width);
                height = Math.max(img.height, height);
            });

            if (width === 0 && height === 0) {
                width = 480;
                height = 640;
            }

            let maxWidth = window.innerWidth / 2;
            let maxHeight = window.innerHeight - 60;

            let scaleWidth = maxWidth / width;
            let scaleHeight = maxHeight / height;

            let scale = Math.min(scaleWidth, scaleHeight);

            width *= scale * 2;
            height *= scale;

            let $flipbook = $(this.$refs.flipbook);
            let $zoomviewport = $(this.$refs.zoomviewport);

            $flipbook.turn("size", width, height);
            $zoomviewport.zoom("resize");

            //$flipbook.turn('resize');
        },
        installTurn() {
            
            let $flipbook = $(this.$refs.flipbook);
            let $zoomviewport = $(this.$refs.zoomviewport);
            if ($flipbook.turn("is")) {
                $flipbook.turn("destroy");
                $zoomviewport.zoom("destroy");
            }
            $flipbook.turn({
                width: window.width,
                height: window.height,
                autoCenter: true,

                when: {
                    turned: (evt, page, view) => {
                        this.currentPage = page;
                    },
                },
            });
            $zoomviewport.zoom({
                flipbook: $flipbook,
                max: 2,
                when: {
                    zoomIn: () => {
                        //$flipbook.turn('resize');
                        
                        $zoomviewport.zoom("resize");
                    },
                },
            });
            this.resize();
            $(window).on("resize", () => {
                if (this.timer) {
                    window.clearTimeout(this.timer);
                }
                this.timer = window.setTimeout(() => {
                    this.resize();
                }, 100);
            });
        },
    },
    computed: {
        imagens() {
            if (!this.documentos) {
                return [];
            }
            return this.documentos
                .map(({ arquivos }) => arquivos)
                .reduce((acc, arquivos) => [...acc, ...arquivos], []);
        },
    },
    async mounted() {
        
        this.installTurn();
        $(this.$refs.flipbook).on("click", ".toolbar button", function () {
            const win = window.open();
            const img = win.document.createElement("img");
            img.src = $(this).data("page");
            const style = win.document.createElement("style");
            style.innerHTML = `
                html, body {
                    margin: 0;
                    padding: 0;                    
                }
            `;
            win.document.head.appendChild(style);
            win.document.body.appendChild(img);
            win.print();
            setTimeout(() => {
                win.close();
            }, 100);
        });
        let mouse_pos = null;
        $(this.$refs.flipbook).on("mousedown", ".page-content img", (evt) => {
            mouse_pos = {
                x: evt.pageX,
                y: evt.pageY,
            };
        });
        $(this.$refs.flipbook).on("mouseup", ".page-content img", (evt) => {
            if (
                this.isZoom &&
                (mouse_pos.x != evt.pageX || mouse_pos.y != evt.pageY)
            ) {
                return;
            }
            if (this.isZoom) {
                this.zoomOut();
            } else {
                this.zoomIn();
            }
            return;
        });
    },
    watch: {
        imagens: {
            immediate: true,
            handler(newValue, oldValue) {
                
                let diff = newValue.filter(
                    (page) => !(oldValue || []).includes(page)
                );

                this.$nextTick(() => {
                    let $flipbook = $(this.$refs.flipbook);
                    let $zoomviewport = $(this.$refs.zoomviewport);
                    if ($flipbook.turn("is")) {
                        $flipbook.turn("removePage", $flipbook.turn("pages"));
                        diff.forEach((page) => {
                            let element = $(`<div class="page-content">
                                <div class="toolbar">
                                    <button data-page="${page}" class="visible-md">IMPRIMIR</button>
                                </div>
                                <img src="${page}" />
                            </div>`);
                            $flipbook.turn("addPage", element);
                        });
                        $flipbook.turn(
                            "addPage",
                            $(`<div>
                            <div class="loading">
                                <svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                    viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
                                        <path fill="#000000" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                                        <animateTransform 
                                            attributeName="transform" 
                                            attributeType="XML" 
                                            type="rotate"
                                            dur="1s" 
                                            from="0 50 50"
                                            to="360 50 50" 
                                            repeatCount="indefinite" />
                                    </path>
                                </svg>
                            </div>
                        </div>`)
                        );
                        //this.resize();
                    }
                });
            },
        },
    },
};
</script>
<style lang="less"  >
.flipbook {
    *,
    *::before,
    *::after {
        box-sizing: border-box;
    }
position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 9999;
    svg {
        width: 100px;
        height: 100px;
        margin: 20px;
        display: inline-block;
    }
    .loading {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: white;
    }
    .viewer {
        width: 100vw;
        height: 100vh;
        background: black;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 48px 1fr;
        overflow: hidden;
    }
    .zoom-viewport {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .toolbar {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .toolbar button {
        margin: 0 4px;
        background: none;
        border: none;
        outline: none;
        color: white;
        padding: 8px;
        background-color: rgba(255, 255, 255, 0.13);
        width: auto;
        min-width: 32px;
        cursor: pointer;
        transition: background-color 0.25s ease-in-out;
    }
    .toolbar button:hover,
    .toolbar button:focus {
        background-color: rgba(255, 255, 255, 0.3);
    }
    .page {
        background: white;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .toolbar {
            button {
                background: rgba(0, 0, 0, 0.5);
                color: white;
                width: auto;
                padding: 0.5em 2em;
                &:hover {
                    background: black;
                }
            }
        }
        img {
            width: 100%;
            height: ~"calc(100% - 48px)";
            object-fit: contain;
            background: white;
            cursor: zoom-in;
        }
    }

    .viewer.zoomed {
        .page {
            img {
                cursor: zoom-out;
            }
        }
        .main-view {
            .zoom-viewport {
            }
        }
    }
}
</style>
